import { useContext } from "react";
import dataApplicationsContext from "../../context/dataApplicationsContext";

export default function Banner() {
  const { windowWidth } = useContext(dataApplicationsContext);

  const myStyle= {
    backgroundImage:`url(${process.env.PUBLIC_URL+ windowWidth > 781 ? "/images/banner_cgv.png" : "/images/mobile.png"})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    ...windowWidth > 781 ? {backgroundPosition: 'right'} : ''
  }

  return  (
    <>
      <div className="banner-container" style={myStyle}>
        <div className="title-banner">
          <h1 className="font-sans font-extrabold text-7xl mb-6 text-shadow">CGV Gestion</h1>
          {/* <img src="/images/millenium_logo.png" alt="logo-millenium" className="logo-millenium"/> */}
          <p className="mb-0 text-shadow">Un outil de gestion du club.</p>
          <p className="text-shadow">Un espace simple pour administrer les effectifs,</p>
          <p className="text-shadow">et bien plus encore !</p>
        </div>
        <div className="banner-illustration">
          {/* <img src="/images/6210046.png" alt="map-gifi" className="map-gifi"/> */}
        </div>
      </div>
      {windowWidth > 781 && 
        <div className="home-content-container">
          <div className="home-content">
            <img src="/images/click.png" alt="click" className="home-content-picto"/>
            <div className="home-content-text">
              <h4 className="home-content-title">Accès Rapide</h4>
              <p className="home-content-descriptif">Basique, simple, simple, basique. Vous n'avez pas les bases.</p>
            </div>
          </div>
          <div className="home-content">
            <img src="/images/calendrier.png" alt="calendrier" className="home-content-picto"/>
            <div className="home-content-text">
              <h4 className="home-content-title">Saisie de données simplifiée</h4>
              <p className="home-content-descriptif">Ne saississez seulement que les champs necessaires. Tout le reste est automatisée.</p>
            </div>
          </div>
          <div className="home-content">
            <img src="/images/rapport.png" alt="rapport" className="home-content-picto"/>
            <div className="home-content-text">
              <h4 className="home-content-title">Tableaux de synthèse</h4>
              <p className="home-content-descriptif">Optimisez vos rapports d'analyse de façon claire et intuitive.</p>
            </div>
          </div>
        </div>
      }
    </>
  )
}